// src/StateStore/selectedUserSlice.js
import { createSlice } from '@reduxjs/toolkit';

// Load initial state from localStorage
const loadSelectedUserFromStorage = () => {
  try {
    const saved = localStorage.getItem('selectedUser');
    return saved ? JSON.parse(saved) : null;
  } catch (error) {
    console.error('Error loading selectedUser from localStorage:', error);
    return null;
  }
};

const initialState = {
  selectedUser: loadSelectedUserFromStorage(),
};

const selectedUserSlice = createSlice({
  name: 'selectedUser',
  initialState,
  reducers: {
    setSelectedUser: (state, action) => {
      state.selectedUser = action.payload;
      // Persist to localStorage
      try {
        if (action.payload) {
          localStorage.setItem('selectedUser', JSON.stringify(action.payload));
        } else {
          localStorage.removeItem('selectedUser');
        }
      } catch (error) {
        console.error('Error saving selectedUser to localStorage:', error);
      }
    },
    clearSelectedUser: (state) => {
      state.selectedUser = null;
      // Remove from localStorage
      try {
        localStorage.removeItem('selectedUser');
      } catch (error) {
        console.error('Error removing selectedUser from localStorage:', error);
      }
    },
  },
});

export const { setSelectedUser, clearSelectedUser } = selectedUserSlice.actions;
export default selectedUserSlice.reducer;
